// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum RoadKind {
  None = 0,
  Straight = 1,
  Corner = 2,
  ThreeWay = 3,
  FourWay = 4
}
